import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Nav } from "./components/Nav";
import { Footer } from "./components/Footer";
import { SmoothScroll } from "./components/SmoothScroll";
import Home from "./pages/Home";

const Identity = lazy(() => import("./pages/Identity"));
const Leadership = lazy(() => import("./pages/Leadership"));
const Ministries = lazy(() => import("./pages/Ministries"));
const Sermons = lazy(() => import("./pages/Sermons"));
const Visit = lazy(() => import("./pages/Visit"));
const Admin = lazy(() => import("./pages/Admin"));
const NotFound = lazy(() => import("./pages/NotFound"));

function Shell() {
  const { pathname } = useLocation();
  return (
    <>
      <SmoothScroll />
      <Nav />
      <main id="main" key={pathname}>
        <Suspense fallback={<div className="min-h-[100svh] bg-[#090909]" />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/identity" element={<Identity />} />
            <Route path="/leadership" element={<Leadership />} />
            <Route path="/ministries" element={<Ministries />} />
            <Route path="/sermons" element={<Sermons />} />
            <Route path="/visit" element={<Visit />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      {pathname !== "/admin" && <Footer />}
      <Toaster theme="dark" position="bottom-right" />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}
